module.exports = __webpack_public_path__ + "img/advancement.8e3023d3.png";